const CARD_HAND_UP_TIME = 15
const FIRST_GAME_STAGE_TIME = 25
const SECOND_GAME_STAGE_TIME = 20
const PURCHASE_GAME_STAGE_TIME = 20

export { CARD_HAND_UP_TIME, FIRST_GAME_STAGE_TIME, SECOND_GAME_STAGE_TIME, PURCHASE_GAME_STAGE_TIME }